/* eslint-disable react/require-default-props */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import styles from '../../styles/partials/icon.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    onClick: PropTypes.func,
    className: PropTypes.string,
};

function Icon({ item = null, onClick = null, className = null }) {
    const { label = null, icon = null } = item || {};
    const onClickIcon = useCallback(() => {
        if (onClick !== null) {
            onClick(item);
        }
    }, [item, onClick]);

    return (
        <button
            className={classNames([styles.container, { [className]: className !== null }])}
            type="button"
            onClick={onClickIcon}
            title={label}
        >
            {icon !== null ? <img className={styles.image} src={icon} alt="" /> : null}
            <div className={styles.label}>
                <span>{label}</span>
            </div>
        </button>
    );
}

Icon.propTypes = propTypes;

export default Icon;
